import React, { useState } from 'react'
import { CircularProgress, IconButton, Tooltip } from '@mui/material'

import Colors from 'utils/Colors'
import SyncIcon from '@mui/icons-material/Sync'
import Button from '@mui/material/Button'
import { patch } from 'services/api'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import { Check } from '@mui/icons-material'
import styles from '../styles'

const ApplicationUpdateButton = ({ application, useTitle = false }) => {
  const [loading, setLoading] = useState(false)

  const [requested, setRequested] = useState(false)

  const classes = styles()

  const token = useSelector((state) => state.auth.access_token)

  const handleClickRequest = async (id) => {
    if (requested) {
      return
    }
    setLoading(true)

    const res = await patch({
      url: `/application?application_uuid=${id}`,
      token,
    })

    if (res) {
      toast.success(
        'Sincronização solicitada. Os dados deverão ser atualizados em alguns instantes',
      )
      setRequested(true)
    }

    setLoading(false)
  }

  const renderIconButton = () => (
    <IconButton
      onClick={() => handleClickRequest(application?.uuid)}
      size="large"
    >
      <SyncIcon
        style={{
          color: Colors.primaryColor,
          fontSize: 20,
        }}
      />
    </IconButton>
  )

  const selectIcon = () => {
    if (requested) {
      return <Check size={20} sytle={{ color: Colors.approvedGreen }} />
    } if (loading) {
      return <CircularProgress size={20} color="primary" />
    } 
      return (
        <SyncIcon
          style={{
            color: Colors.primaryColor,
            fontSize: 20,
          }}
        />
      )
  }

  const renderLabeledButton = () => (
    <Button
      size="small"
      variant="outlined"
      onClick={() => handleClickRequest(application?.uuid)}
      startIcon={selectIcon()}
    >
      {!requested ? 'Sincronizar' : 'Solicitado'}
    </Button>
  )

  return !useTitle && loading ? (
    <CircularProgress size={18} color="primary" />
  ) : (
    <Tooltip
      arrow
      placement="top"
      title={
        <b className={classes.tooltipText}>
          {!requested ? 'Solicitar sincronia de dados alterados na Greenhouse. Pode levar alguns minutos.' : 'Atualização solicitada. Você pode acompanhar o resultado da solicitação na página de Logs.'}
        </b>
      }
    >
      {useTitle ? renderLabeledButton() : renderIconButton()}
    </Tooltip>
  )
}

export default ApplicationUpdateButton
